import { render, staticRenderFns } from "./LeadgenGarageSelect.vue?vue&type=template&id=64a8964e"
import script from "./LeadgenGarageSelect.vue?vue&type=script&lang=js"
export * from "./LeadgenGarageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports